export default __webpack_public_path__ + "4688f1ec3dd9a8f2098b3a8cc2210215.svg";